var map = {
	"./al.svg": 49455,
	"./ar.svg": 64521,
	"./ar2.svg": 20409,
	"./ar3.svg": 8040,
	"./ar5.svg": 63574,
	"./az.svg": 46289,
	"./ba.svg": 30199,
	"./cart.svg": 20482,
	"./china.svg": 94713,
	"./cn.svg": 90199,
	"./cnr.svg": 13175,
	"./copy.svg": 92815,
	"./cs.svg": 21010,
	"./de.svg": 50337,
	"./desk-bell.svg": 84335,
	"./en.svg": 72105,
	"./es.svg": 19484,
	"./et.svg": 94115,
	"./fa.svg": 18331,
	"./fr.svg": 84824,
	"./gr.svg": 78983,
	"./hamburger.svg": 84813,
	"./home.svg": 26669,
	"./hr.svg": 56738,
	"./hu.svg": 31405,
	"./icon-close.svg": 41968,
	"./il.svg": 46167,
	"./info.svg": 45316,
	"./it.svg": 11535,
	"./ja.svg": 59119,
	"./ka.svg": 50680,
	"./ko.svg": 25134,
	"./ky.svg": 46064,
	"./kz.svg": 3107,
	"./loading_product.svg": 64848,
	"./logo.svg": 11085,
	"./lv.svg": 34394,
	"./menu.svg": 93805,
	"./minus.svg": 84896,
	"./mn.svg": 82801,
	"./nav_1.svg": 57359,
	"./nav_10.svg": 40045,
	"./nav_11.svg": 60332,
	"./nav_12.svg": 15679,
	"./nav_13.svg": 10926,
	"./nav_2.svg": 94684,
	"./nav_3.svg": 48957,
	"./nav_4.svg": 15026,
	"./nav_5.svg": 52963,
	"./nav_6.svg": 7824,
	"./nav_7.svg": 20065,
	"./nav_8.svg": 97270,
	"./nav_9.svg": 84391,
	"./nl.svg": 95526,
	"./pl.svg": 66908,
	"./plus.svg": 74536,
	"./pt.svg": 9764,
	"./recognizing-in-progress.svg": 20505,
	"./ro.svg": 69025,
	"./ru.svg": 235,
	"./rush-8.svg": 86773,
	"./service.svg": 56745,
	"./service_0.svg": 96260,
	"./service_1.svg": 74277,
	"./service_2.svg": 54406,
	"./service_3.svg": 855,
	"./service_4.svg": 5784,
	"./service_5.svg": 81289,
	"./service_6.svg": 55706,
	"./sk.svg": 99882,
	"./sl.svg": 28981,
	"./sv.svg": 68703,
	"./tat.svg": 4363,
	"./tg.svg": 18099,
	"./tr.svg": 77886,
	"./ua.svg": 25470,
	"./uz.svg": 5157,
	"./wave.svg": 64339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65526;